<template>
  <v-row>
    <v-col cols="12">
      <div class="text-subtitle-1 font-weight-bold">
        Datos generales
      </div>
    </v-col>
    <v-col cols="3">
      <ATextField
        label="Nombre"
        :value="preregistro.nombre"
      />
    </v-col>
    <v-col cols="3">
      <ATextField
        label="Segundo nombre"
        :value="preregistro.segundo_nombre"
      />
    </v-col>
    <v-col cols="3">
      <ATextField
        label="Apellido paterno"
        :value="preregistro.apaterno"
      />
    </v-col>
    <v-col cols="3">
      <ATextField
        label="Apellido materno"
        :value="preregistro.amaterno"
      />
    </v-col>
    <v-col cols="3">
      <ATextField
        label="Fecha de nacimiento"
        :value="preregistro.fecha_nacimiento"
      />
    </v-col>
    <v-col cols="3">
      <ATextField
        label="Género"
        :value="preregistro.cat_genero && preregistro.cat_genero.nombre"
      />
    </v-col>
    <v-col cols="3">
      <ATextField
        label="Estado civíl"
        :value="preregistro.cat_estado_civil && preregistro.cat_estado_civil.estado_civil"
      />
    </v-col>
    <v-col cols="3">
      <ATextField
        label="RFC"
        :value="preregistro.rfc"
      />
    </v-col>
    <v-col cols="3">
      <ATextField
        label="CURP"
        :value="preregistro.curp"
      />
    </v-col>
    <template v-if="preregistro.direccion">
      <v-col cols="12">
        <div class="text-subtitle-1 font-weight-bold">
          Domicilio
        </div>
      </v-col>
      <v-col cols="6">
        <ATextField
          label="Calle"
          :value="preregistro.direccion.calle"
        />
      </v-col>
      <v-col cols="3">
        <ATextField
          label="No. exterior"
          :value="preregistro.direccion.ext"
        />
      </v-col>
      <v-col cols="3">
        <ATextField
          label="No. interior"
          :value="preregistro.direccion.int"
        />
      </v-col>
      <v-col cols="6">
        <ATextField
          label="Entre calle"
          :value="preregistro.direccion.entrecalles_1"
        />
      </v-col>
      <v-col cols="6">
        <ATextField
          label="Entre calle 2"
          :value="preregistro.direccion.entrecalles_2"
        />
      </v-col>
      <v-col cols="4">
        <ATextField
          label="Colonia"
          :value="preregistro.direccion.colonia"
        />
      </v-col>
      <v-col cols="3">
        <ATextField
          label="Estado"
          :value="preregistro.direccion.cat_municipio.cat_estado.nombre"
        />
      </v-col>
      <v-col cols="3">
        <ATextField
          label="Municipio"
          :value="preregistro.direccion.cat_municipio.nombre"
        />
      </v-col>
      <v-col cols="2">
        <ATextField
          label="Código postal"
          :value="preregistro.direccion.cp"
        />
      </v-col>
    </template>
    <v-col cols="12">
      <div class="text-subtitle-1 font-weight-bold">
        Datos de la institución
      </div>
    </v-col>
    <v-col cols="3">
      <ATextField
        label="Antigüedad en la institución"
        :value="preregistro.antiguedad_institucion"
      />
    </v-col>
    <v-col cols="3">
      <ATextField
        label="Institución"
        :value="preregistro.institucion"
      />
    </v-col>
    <v-col cols="3">
      <ATextField
        label="Área de adscripción"
        :value="preregistro.area_adscripcion"
      />
    </v-col>
    <v-col cols="3">
      <ATextField
        label="CUIP"
        :value="preregistro.cuip"
      />
    </v-col>
    <v-col
      cols="12"
      class="text-right"
    >
      <APrimaryButton
        label="Cerrar"
        @click="CLOSE_DIALOG()"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import APrimaryButton from '../atoms/APrimaryButton.vue';
import ATextField from '../atoms/ATextField.vue';

export default {
  components: { ATextField, APrimaryButton },

  computed: {
    ...mapState({
      preregistro: (state) => state.preregistro.preregistro,
    }),
  },

  methods: {
    ...mapMutations('dialog', ['CLOSE_DIALOG']),
  },
};
</script>
